import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { GetBlockAuditResponse } from '@responses/audits';
import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';

import type { QueryFactory } from './factory.types';

export const fetchBlockAudit = async (id: string): Promise<GetBlockAuditResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: `blocks/${id}/audit`,
  });

  const response = await axios(networkPayload);
  return response.data;
};

export const blockAuditQueries = {
  // `version` (the block's updated_at) is in the key so a save becomes a new query —
  // React Query refetches automatically without polling, mirroring entityQueries.auditLog.
  forBlock: (id: string, version?: string) =>
    queryOptions({
      queryKey: ['block-audit', id, version] as const,
      queryFn: () => fetchBlockAudit(id),
    }),
} satisfies QueryFactory;
